var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7332 49.816L21.6685 36.645L18.4819 39.8315L34.7332 56.0828L61.7125 29.1035L58.6322 25.917L34.7332 49.816Z",
    fill: "#47BE7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82C63.6244 82 82 63.6244 82 41C82 18.3756 63.6244 0 41 0C18.3756 0 0 18.3756 0 41C0 63.6244 18.3756 82 41 82ZM41 4.46114C61.0751 4.46114 77.5389 20.8187 77.5389 41C77.5389 61.1814 61.0751 77.5389 41 77.5389C20.9249 77.5389 4.46114 61.0751 4.46114 41C4.46114 20.9249 20.9249 4.46114 41 4.46114Z",
    fill: "#47BE7D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.03a20ed6a1b9773a7f082b2a7f9fe106.svg";
export { ForwardRef as ReactComponent };